<template>
  <div id="dividend-report p-2 m-2">
    <!-- ================= FILTER ================= -->
    <div class="filter-btn-group">
      <div class="radio-filter">
        <div class="wrapper">
          <input
            type="radio"
            name="select"
            id="dividend-report-individual"
            class="option-input-1"
            value="false"
            v-model="cumulative"
          />
          <input
            type="radio"
            name="select"
            id="dividend-report-cumulative"
            class="option-input-2"
            value="true"
            v-model="cumulative"
          />

          <label for="dividend-report-individual" class="option option-1">
            <div class="dot"></div>
            <span>Individual</span>
          </label>

          <label for="dividend-report-cumulative" class="option option-2">
            <div class="dot"></div>
            <span>Cumulative</span>
          </label>
        </div>
      </div>
    </div>

    <!-- ================= TABLE ================= -->
    <div class="grid-table">
      <v-card flat rounded="lg" class="dividend-report-card">
      <v-data-table
        :headers="headers"
        :items="cumulativeDividends"
        :items-per-page="5"
        :items-per-page-options="[10, 15, 20, 30, 50, 100, 200]"
        item-value="dividend_id"
        class="custom-data-table"
      >
        <!-- Platform -->
        <template v-slot:[`item.platform_name`]="{ item }">
          <span>{{ getPlatformNames(item.platform_id) }}</span>
        </template>

        <!-- Amount -->
        <template v-slot:[`item.amount`]="{ item }">
          <span>{{ $helper.formatPrice(item.amount) }}</span>
        </template>

        <!-- Date -->
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ $helper.formatDate(item.created_at, true) }}</span>
        </template>
      </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { useAlertStore, platformStore } from '@/stores';
import gql from 'graphql-tag';

/* ================= GRAPHQL ================= */

const CUMULATIVE_DIVIDENDS_QUERY = gql`
  query CumulativeDividends($cumulative: [Boolean]) {
    cumulativeDividends(cumulative: $cumulative) {
      dividend_id
      platform_id
      stock_id
      qty
      amount
      created_at
      stock {
        name
      }
    }
  }
`;

export default {
  name: 'Dividend-Report',

  data() {
    return {
      cumulativeDividends: [] as any[],
      cumulative: 'true',

      headers: [
        { title: 'Dividend Id', key: 'dividend_id' },
        { title: 'Platform', key: 'platform_name' },
        { title: 'Stock', key: 'stock.name' },
        { title: 'Qty', key: 'qty' },
        { title: 'Amount', key: 'amount' },
        { title: 'Date', key: 'created_at' }
      ]
    };
  },

  setup() {
    const platformStore$ = platformStore();

    // ✅ FIX: use platformList (exists in store)
    const { platformList } = storeToRefs(platformStore$);

    return {
      alertStore$: useAlertStore(),
      platformList
    };
  },

  watch: {
    cumulative() {
      this.$apollo.queries.cumulativeDividends.refetch();
    }
  },

  methods: {
    getPlatformNames(platformId: any) {
      if (!platformId || !this.platformList?.length) return '-';

      const ids = Array.isArray(platformId)
        ? platformId
        : String(platformId).split(',');

      return ids
        .map(id =>
          this.platformList.find(
            (p: any) => String(p.platform_id) === String(id)
          )?.name
        )
        .filter(Boolean)
        .join(', ');
    }
  },

  apollo: {
    cumulativeDividends: {
      query: CUMULATIVE_DIVIDENDS_QUERY,
      variables() {
        return {
          cumulative: this.cumulative === 'false' ? false : true
        };
      },
      error(error: any) {
        this.alertStore$.error(error.message);
      }
    }
  }
};
</script>

<style scoped>
.wrapper {
  box-shadow: none;
  border: 1px solid var(--border);
}

.dividend-report-card {
  border: 1px solid var(--border);
  margin-top: 16px;
}

.custom-data-table :deep(thead th) {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border) !important;
}

.custom-data-table :deep(tbody td) {
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f2f4 !important;
}

.custom-data-table :deep(tbody tr:hover) {
  background-color: #f8f9fb;
}
</style>